import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { InfoBox } from './InfoBox';
import { Button } from 'src/domains/common/components/button/button';
import { CampaignModel } from 'src/domains/casino/state/AppCasino/store/campaign-store/CampaignModel';

interface PromotionDetailsType {
    campaignModel: CampaignModel;
}

export const PromoCodes = observer('PromoCodes', ({ campaignModel }: PromotionDetailsType) => {
    const [showMore, setShowMore] = useState(false);
    const promoCodes = campaignModel.promoCodesArray;
    if (promoCodes === null) {
        return null;
    }
    const isMoreThan6 = promoCodes.length > 6;
    const promoCodesForView = isMoreThan6 && showMore === false ? promoCodes.slice(0, 6) : promoCodes;
    const created = `Created (${promoCodes.length})`;
    const handleOnClick = (): void => {
        setShowMore(!showMore);
    };
    return (
        <InfoBox>
            <h3 className='m-0 mb-4 text-base font-semibold'>Promo Code</h3>
            <div className='flex gap-8'>
                <div className='w-full'>
                    <div className='flex flex-col'>
                        <h4 className='text-sm m-0 mb-2 font-semibold'>{created}</h4>
                        <div className='relative'>
                            <div className='flex items-center'>
                                <h5 className='m-0 text-xs text-muted-foreground font-normal w-1/2'>Promo Code</h5>
                                <h5 className='m-0 text-xs text-muted-foreground font-normal w-1/2'>Use Limit</h5>
                            </div>

                            <div className='flex flex-col-reverse divide-y-2 divide-y-reverse divide-border divide-solid'>
                                {promoCodesForView.map((promoCode) => (
                                    <div
                                        key={`${promoCode.promoCode}-${campaignModel.id}`}
                                        className='flex items-center w-full border-r-0 border-l-0 h-[36px]'
                                    >
                                        <div className='text-sm border-right-  w-1/2'>{promoCode.promoCode}</div>
                                        <div className='text-sm  w-1/2'>{promoCode.numberOfUses}</div>
                                    </div>
                                ))}
                            </div>
                            <div></div>
                            {isMoreThan6 ? (
                                <div>
                                    {showMore ? null : (
                                        <div className='absolute bottom-10 left-0 right-0 h-10 bg-gradient-to-t from-white to-transparent pointer-events-none' />
                                    )}

                                    <Button
                                        className='flex mx-auto'
                                        variant='outline'
                                        onClick={handleOnClick}
                                    >
                                        {showMore ? 'View less Promo Codes' : 'View all Promo Codes'}
                                    </Button>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </InfoBox>
    );
});
